import { render, staticRenderFns } from "./OrdersTableReports.vue?vue&type=template&id=2d27471c"
import script from "./OrdersTableReports.vue?vue&type=script&lang=js"
export * from "./OrdersTableReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports